import React, { useState } from 'react';

const agentPrices = [
  { category: 'Office Space (per sqft)', market: '$42.50',    analyzed: '$38.20',    delta: '-10%', positive: true  },
  { category: 'Commercial Lease',        market: '$3,200/mo', analyzed: '$2,900/mo', delta: '-9%',  positive: true  },
  { category: 'Retail Storefront',       market: '$5,800/mo', analyzed: '$6,100/mo', delta: '+5%',  positive: false },
];

const agentBlogPosts = [
  {
    title: 'AI-Powered Price Analysis: How Startup Agents Are Disrupting Commercial Real Estate',
    date: 'Apr 20, 2025', category: 'Market Analysis', readTime: '5 min read',
    excerpt: 'Our agent engine analyzed over 12,000 commercial listings this quarter to surface pricing gaps that human analysts miss.',
  },
  {
    title: 'From Data to Decision: The Startup Agent Workflow Explained',
    date: 'Apr 15, 2025', category: 'Product Update', readTime: '4 min read',
    excerpt: "We've rebuilt our analysis pipeline to deliver insights in real time.",
  },
  {
    title: 'Case Study: How Acme Corp Saved 9% on Commercial Lease Costs',
    date: 'Apr 10, 2025', category: 'Case Study', readTime: '3 min read',
    excerpt: "Using the Price Analyzer agent, Acme Corp's facilities team identified a $2,900/mo lease opportunity against a $3,200/mo market average.",
  },
];

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const GreenBtn = ({ label = 'View', onClick, extraClass = '' }) => (
  <button className={`btn-primary bg-green1-dark text-white brd-5 font-12 fw500 p-5-10 ${extraClass}`} onClick={onClick}>
    {label}
  </button>
);

const StartupAgentsTab = () => {
  const [agentTab, setAgentTab] = useState('insights');

  return (
    <SectionCard>
      <CardHeader title="Startup Agents — Price Insights" action="Refresh" />
      <div className="flex gap-5 m-b-15 br-btm-grey p-b-10">
        {['insights', 'blog'].map(tab => (
          <button key={tab}
            className={`brd-5 font-12 fw500 p-5-10 no-border pointer ${agentTab === tab ? 'bg-green1-dark text-white' : 'bg-grey-1 color-black'}`}
            onClick={() => setAgentTab(tab)}>
            {tab === 'insights' ? 'Price Insights' : 'Agent Blog'}
          </button>
        ))}
      </div>

      {agentTab === 'insights' && (
        <div className="table-responsive">
          <table className="table shadow-small">
            <thead><tr>{['Category', 'Market Price', 'Analyzed Price', 'Delta'].map(h => <th key={h}>{h}</th>)}</tr></thead>
            <tbody>
              {agentPrices.map((row, i) => (
                <tr key={i}>
                  <td>{row.category}</td>
                  <td className="lgrey">{row.market}</td>
                  <td className="fw500 dark-navy">{row.analyzed}</td>
                  <td><span className={`fw700 ${row.positive ? 'green' : 'red'}`}>{row.delta}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {agentTab === 'blog' && agentBlogPosts.map((post, i) => (
        <div key={i} className="flex coldir gap-5 p-t-12 p-b-12 br-btm-grey">
          <div className="flex aligncenter gap-8 m-b-4">
            <span className="badge-3 bg-blue-white color-highlight">{post.category}</span>
            <span className="font-11 lgrey">{post.readTime}</span>
          </div>
          <div className="fw500 font-14 dark-navy">{post.title}</div>
          <div className="font-12 lgrey lh-19">{post.excerpt}</div>
          <div className="flex justspacebetween aligncenter m-t-4">
            <span className="font-11 lgrey">{post.date}</span>
            <GreenBtn label="Read More" />
          </div>
        </div>
      ))}
    </SectionCard>
  );
};

export default StartupAgentsTab;